import { render } from "./GruposApoio.vue?vue&type=template&id=33a1581a&scoped=true"
import script from "./GruposApoio.vue?vue&type=script&lang=js"
export * from "./GruposApoio.vue?vue&type=script&lang=js"

import "./GruposApoio.vue?vue&type=style&index=0&id=33a1581a&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a1581a"]])

export default __exports__